import {
  BiPanelRuleFilter,
  BiPanelRuleFilterOptionsState,
  BiPanelRuleFormState,
  BiPanelRuleHistoryState,
  BiPanelRuleModel,
  BiPanelRuleTablePagination,
  BiPanelRuleTableState,
  EnumOption,
  BiPanelLevelCode,
  PaymentModelCode,
  BiParameterTypeCode,
  LifeCountRuleCode,
  CompetencyTypeCode,
} from './bi-panel-rule-types';
import { BIFilterOptionFieldState, BIFilterOptionPagination } from '../bi-control-panel/bi-control-panel-types';

export const BI_PANEL_RULE_AUTOCOMPLETE_PAGE_SIZE = 20;
export const BI_PANEL_RULE_TABLE_DEFAULT_PAGE_SIZE = 10;
export const BI_PANEL_RULE_MAX_PARAMETERS_PER_RULE = 2;

export const BI_PANEL_LEVEL_OPTIONS: EnumOption<BiPanelLevelCode>[] = [
  { code: 'CARRIER', label: 'Operadora' },
  { code: 'FINANCIAL_GROUP', label: 'Grupo Financeiro' },
  { code: 'CONTRACT', label: 'Contrato' },
];

export const BI_PAYMENT_MODEL_OPTIONS: EnumOption<PaymentModelCode>[] = [
  { code: 'PRE_PAGAMENTO', label: 'Pré Pagamento' },
  { code: 'POS_PAGAMENTO', label: 'Pós Pagamento' },
];

export const BI_PARAMETER_TYPE_OPTIONS: EnumOption<BiParameterTypeCode>[] = [
  { code: 'LIFE_COUNT', label: 'Contagem de Vidas' },
  { code: 'COMPETENCY', label: 'Exibição de Competência' },
];

export const BI_LIFE_COUNT_RULE_OPTIONS: EnumOption<LifeCountRuleCode>[] = [
  { code: 'PC', label: 'PC' },
  { code: 'FATURA', label: 'Fatura' },
  { code: 'DADO_FECHADO', label: 'Dado Fechado' },
];

// Códigos string no combo: o v-autocomplete não lida bem com `false` como valor selecionado
export const BI_RULE_STATUS_OPTIONS: EnumOption<'ACTIVE' | 'INACTIVE'>[] = [
  { code: 'ACTIVE', label: 'Ativo' },
  { code: 'INACTIVE', label: 'Inativo' },
];

export const BI_COMPETENCY_TYPE_OPTIONS: EnumOption<CompetencyTypeCode>[] = [
  { code: 'MENSAL', label: 'Mensal' },
  { code: 'QUINZENAL', label: 'Quinzenal' },
];

// Especificação: Mensal é o padrão no pré pagamento e Quinzenal no pós; com os dois modelos não há padrão definido
export const defaultCompetencyType = (paymentModels: PaymentModelCode[]): CompetencyTypeCode | null => {
  if (paymentModels.length !== 1) return null;

  return paymentModels[0] === 'PRE_PAGAMENTO' ? 'MENSAL' : 'QUINZENAL';
};

export const defaultFilterOptionPagination = (): BIFilterOptionPagination => ({
  page: -1,
  size: BI_PANEL_RULE_AUTOCOMPLETE_PAGE_SIZE,
  totalElements: 0,
  hasNext: true,
});

export const defaultFilterOptionFieldState = (): BIFilterOptionFieldState => ({
  items: [],
  loading: false,
  initialized: false,
  searchInput: '',
  pagination: defaultFilterOptionPagination(),
});

export const defaultTablePagination = (): BiPanelRuleTablePagination => ({
  page: 0,
  size: BI_PANEL_RULE_TABLE_DEFAULT_PAGE_SIZE,
  totalElements: 0,
  totalPages: 0,
});

export const defaultFilter = (): BiPanelRuleFilter => ({
  carrierIds: [],
  paymentModels: [],
  financialGroupId: null,
  contractIds: [],
  active: null,
});

export const defaultFilterOptions = (): BiPanelRuleFilterOptionsState => ({
  financialGroup: defaultFilterOptionFieldState(),
  carrier: defaultFilterOptionFieldState(),
  contract: defaultFilterOptionFieldState(),
});

export const defaultTableState = (): BiPanelRuleTableState => ({
  rows: [],
  loading: false,
  pagination: defaultTablePagination(),
});

export const defaultFormState = (): BiPanelRuleFormState => ({
  show: false,
  mode: 'create',
  step: 1,
  submitting: false,
  loading: false,
  ruleId: null,
  level: null,
  carrierId: null,
  financialGroupId: null,
  contractId: null,
  paymentModels: [],
  parameters: [],
  scopeLabel: '',
});

export const defaultHistoryState = (): BiPanelRuleHistoryState => ({
  rule: [],
  parameter: [],
  loading: false,
});

export const defaultBiPanelRuleModel = (): BiPanelRuleModel => ({
  initialized: false,
  filter: defaultFilter(),
  filterOptions: defaultFilterOptions(),
  table: defaultTableState(),
  levelOptionNames: {},
  form: defaultFormState(),
  history: defaultHistoryState(),
});
